import * as Sentry from '@sentry/react-native';
import { mapExchange } from 'urql';
import {
  getFirstGraphQLErrorMessage,
  shouldCaptureGraphQLError,
  shouldEndSessionAfterAuthRecovery,
} from '@/client/exchanges/authFailure';
import signOut from '@/utils/signOut';

export default mapExchange({
  onError(error, operation) {
    const definition = operation.query.definitions[0];

    if (
      definition.kind === 'OperationDefinition' &&
      shouldCaptureGraphQLError(error)
    ) {
      const operationName = definition.name?.value ?? 'AnonymousOperation';
      const operationError = new Error(`${operationName}: ${error.message}`);

      // biome-ignore lint/suspicious/noConsole: wanted to help user debug
      console.error(operationError);
      Sentry.captureException(operationError);
    }

    if (shouldEndSessionAfterAuthRecovery(error)) {
      const message = getFirstGraphQLErrorMessage(error);
      // biome-ignore lint/suspicious/noConsole: wanted to help user debug
      console.error(message);
      void signOut();
    }
  },
});
